import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { Meta, Title } from '@angular/platform-browser';
import { DataService } from './services/dataService.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, AfterViewInit {
    loading: Boolean = true;
    currentUrl: any;

    constructor(
        private router: Router,
        private titleService: Title,
        private dataService: DataService,
        private location: Location,
        private meta: Meta,
    ) {
        // Subscribe to navigation events
        router.events.subscribe((event) => {
            const lastRoute = this.currentUrl;
            if (location.path() !== '') {
                this.currentUrl = location.path();
            } else {
                this.currentUrl = '/';
            }

            // Only when the route actually changes
            if (this.currentUrl !== lastRoute) {

                // Always scroll to top
                if (typeof window !== 'undefined') {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                    }, 700);
                }

                // Get page data from the backend
                this.dataService.getPost(this.currentUrl)
                    .subscribe(res => {
                        // Set page title
                        this.setTitle(res);

                        // Set meta tags
                        this.setMetaData(res);
                    });
            }
        });
    }

    setTitle(res) {
        this.titleService.setTitle('Bloomy Ideas | ' + res.title);
    }

    setMetaData(res) {
        // TODO: Add more meta tags

        // We need to remove all the existing meta tags before adding new ones to avoid duplicates
        // Remove existing meta tags
        this.meta.removeTag('itemprop="name"');
        this.meta.removeTag('property="og:title"');

        // Add new meta tags
        this.meta.addTag({itemprop: 'name', content: res.title});
        this.meta.addTag({property: 'og:title', content: res.title});
    }

    ngOnInit() {
        this.loading = true;
    }

    ngAfterViewInit() {
        this.router.events
            .subscribe((event) => {
                if (event instanceof NavigationStart && event.id !== 1) {
                    this.loading = true;
                } else if (event instanceof NavigationEnd || event instanceof NavigationCancel) {
                    setTimeout(() => {
                        this.loading = false;
                    }, 500);
                }
            });
    }
}




// WEBPACK FOOTER //
// E:/MBP/BloomyNG/src/app/app.component.ts